<template>
  <v-container fluid>
    <v-card>
      <v-toolbar class="accent">
        <h3>Airports</h3>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="airports"
        :search="search"
        :loading="loading"
      ></v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import AdminLayout from "@/layouts/AdminLayout";
import api from "../../services/axiosconfig";

export default {
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        { text: "IATA Code", align: "start", value: "citycode" },
        { text: "Airport Name", align: "start", value: "cityname" },
        { text: "Country", align: "start", value: "country" },
        { text: "Region", align: "start", value: "region" },
      ],
      airports: [],
    };
  },
  mounted() {
    this.getAirports();
  },
  created() {
    this.$emit(`update:layout`, AdminLayout);
  },
  methods: {
    async getAirports() {
      try {
        this.loading = true;
        const response = await api.get("/aejmis/api/airports");
        this.airports = response.data;
        this.loading = false;
        return;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.loading = false;
        this.$toasted.global.optimus_error({
          message: "Could not retrieve information. Try after sometime.",
        });
      }
    },
  },
};
</script>
